/**
 * localStorage keys. CSTS Cat-4 named map + version suffixes for migration.
 * Bump the version suffix when the payload shape changes.
 *
 * Keys use a brand-agnostic `game.*` prefix so this file stays byte-identical
 * across the Popphin and Billy Bisson games (FLME Layer 5 shared config).
 * localStorage is scoped per origin (popphin.com vs billybisson.com), so
 * collisions across games are structurally impossible.
 */

export const STORAGE_KEYS = {
  SAVE_MAIN: "game.save.v1",
  SETTINGS: "game.settings.v1",
  FIRST_LAUNCH_ACK: "game.first-launch-ack.v1",
  CODEX: "game.codex.v1",
  ACHIEVEMENTS: "game.achievements.v1"
} as const;
